module.exports = __webpack_public_path__ + "static/media/9.ecc2cd72.jpg";